import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCircle } from "@fortawesome/free-solid-svg-icons";
import IInput from "../iInput/IInput";
import ICheckProps from "./ICheck.props";
import ICheckState from "./ICheck.state";

export default class ICheck extends IInput<ICheckProps, ICheckState> {
  state: ICheckState = {
    value: false,
    isExpanded: false
  };

  componentDidMount(): void {
    const init = !!this.props.init;
    this.setState({ value: init }, () => super.triggerInput());
  }

  componentDidUpdate(prevProps: Readonly<ICheckProps>): void {
    if (this.props.init !== prevProps.init) {
      this.setState({ value: !!this.props.init });
    }
  }

  toggleExpanded = () => {
    if (this.props.disabled) {
      return;
    }

    if (this.props.onExpandRow) {
      this.props.onExpandRow();
    }

    this.setState({ isExpanded: !this.state.isExpanded });
  };

  onChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const checked = !!evt.target.checked;
    this.props.setter(this.props.name, checked);
    this.props.onChange && this.props.onChange(checked);
    this.setState({ value: checked });
  };

  renderCollapsed = () => {
    const displayValue = this.state.value ? "Sí" : "No";

    return (
      <div
        onClick={this.toggleExpanded}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "6px 10px",
          backgroundColor: this.props.disabled ? "unset" : "#f5f5f5",
          borderRadius: "4px",
          cursor: this.props.disabled ? "default" : "pointer",
          minHeight: "32px",
          border: this.props.disabled ? "unset" : "1px solid #e0e0e0",
          transition: "all 0.2s ease",
          lineHeight: "19px"
        }}
        onMouseEnter={e => {
          if (!this.props.disabled) {
            e.currentTarget.style.backgroundColor = "#ebebeb";
          }
        }}
        onMouseLeave={e => {
          if (!this.props.disabled) {
            e.currentTarget.style.backgroundColor = "#f5f5f5";
          }
        }}
      >
        <div
          style={{
            color: "#333",
            fontSize: "14px"
          }}
        >
          {this.props.cellFormatter
            ? this.props.cellFormatter(displayValue)
            : displayValue}
        </div>
        {!this.props.disabled && (
          <FontAwesomeIcon
            icon={this.state.value ? faCheckCircle : faCircle}
            color="#999"
            style={{
              marginLeft: "8px",
              marginBottom: "4px",
              flexShrink: 0,
              fontSize: "12px"
            }}
          />
        )}
      </div>
    );
  };

  render() {
    if (this.props.hidden) {
      return null;
    }

    const isExpanded = this.props.rowExpanded || this.state.isExpanded;
    const id = `${this.props.formKey || ""}-${this.props.name}`;
    const marginClass = this.props.addTopMargin !== false ? "mt-4" : "mt-2";
    const inputStyle: any = this.props.onTable
      ? {
          position: "unset",
          margin: "0 8px 0 0",
          verticalAlign: "middle"
        }
      : undefined;

    const content = (
      <div
        className={`form-group mb-0 ${this.props.onTable ? "" : marginClass}`}
      >
        <div
          className="form-check"
          style={{
            lineHeight: "16px",
            marginTop: this.props.onTable ? "8px" : undefined,
            marginLeft: this.props.onTable ? "0px" : "15px",
            padding: this.props.onTable ? "0px" : "4px",
            background: this.props.onTable ? "transparent" : "#eee"
          }}
        >
          <input
            className="form-check-input"
            style={inputStyle}
            type="checkbox"
            id={id}
            checked={!!this.state.value}
            onChange={this.onChange}
            disabled={!!this.props.disabled}
          />
          {this.props.label && (
            <label
              className="form-check-label"
              htmlFor={id}
              style={{ verticalAlign: "baseline" }}
            >
              {this.props.label}
            </label>
          )}
        </div>
        {!!this.props.dirty && !!this.props.message && (
          <div
            className="text-danger"
            style={{
              fontSize: "12px",
              marginLeft: this.props.onTable ? "0px" : "15px"
            }}
          >
            {this.props.message}
          </div>
        )}
      </div>
    );

    if (this.props.onTable) {
      if (this.props.cellCollapsed && !isExpanded) {
        return (
          <td className={this.props.classCol || ""}>
            {this.renderCollapsed()}
          </td>
        );
      }
      return <td className={this.props.classCol || ""}>{content}</td>;
    }

    return <div className={this.btsClassName()}>{content}</div>;
  }
}
